import React, { useState, useEffect } from "react";

import { Col, Form, Input, Row, InputGroupText, InputGroup, Tooltip } from "reactstrap";
import { ButtonPrimary, FormArea, LabelRegister, Picture } from "./style";

import picture from "../images/picture.svg"
import edit from "../images/Grupo_25.svg"
// Removidos ícones não utilizados
import { SlInfo } from 'react-icons/sl'
import LoadinSpinner from "./LoadinSpinner";
import { useMutation } from "@apollo/client";
import { GET_BY_USER_ID, INSERT_USER_EN, INSERT_USER_ES, UPDATE_USER_EN, UPDATE_USER_ES, UPDATE_USER_PT } from "../gql/user";
import { minioUploadFile } from "../service/fileUtils";
import { useDispatch, useSelector } from "react-redux";
import { setDepartment, setPreviewImage, setLogo, setSaveContactOptions, setRole, setUsername, setLinkedin, setEmail, setPhone, setUnity, setWhatsapp, setLoadingForm } from "../redux/slices/userSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getUserId } from "../auth";
import { optionsLogos } from "../constants/logo";
import { saveContactOptions } from "../constants/saveContactsOptions";

function Register({ userInfo }) {
    const [image, setImage] = useState()
    const { t } = useTranslation('common')
    const userRedux = useSelector(state => state)
    const dispatch = useDispatch()

    const [whatsappTooltipOpen, setWhatsappTooltipOpen] = useState(false);
    const toggleWhatsapp = () => setWhatsappTooltipOpen(!whatsappTooltipOpen);
    
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);

    const [saveContactTooltipOpen, setSaveContactTooltipOpen] = useState(false)
    const toggleSaveContact = () => setSaveContactTooltipOpen(!saveContactTooltipOpen)

    const [userUpdatePt] = useMutation(UPDATE_USER_PT, {
        refetchQueries: [
            {
                query: GET_BY_USER_ID,
                variables: { id: getUserId() }
            }
        ]
    })
    const [userUpdateEs] = useMutation(UPDATE_USER_ES, {
        refetchQueries: [
            {
                query: GET_BY_USER_ID,
                variables: { id: getUserId() }
            }
        ]
    })
    const [userUpdateEn] = useMutation(UPDATE_USER_EN, {
        refetchQueries: [
            {
                query: GET_BY_USER_ID,
                variables: { id: getUserId() }
            }
        ]
    })
    const [insertEn] = useMutation(INSERT_USER_EN, {
        refetchQueries: [
            {
                query: GET_BY_USER_ID,
                variables: { id: getUserId() }
            }
        ]
    })
    const [insertEs] = useMutation(INSERT_USER_ES, {
        refetchQueries: [
            {
                query: GET_BY_USER_ID,
                variables: { id: getUserId() }
            }
        ]
    })

    const handleFile = (event) => {
        const { files } = event.target
        dispatch(setPreviewImage(URL.createObjectURL(files[0])));
        setImage(files[0])
    }

    const handleWhats = (event) => {
        const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
        var str = event.target.value.replace(/[^0-9]/g, "").slice(0, 11);

        const result = str.replace(regex, "($1) $2-$3");

        dispatch(setWhatsapp(result));
    }
    const handleSelectLogo = (event) => {
        const rawValue = event.target.value;
        const id = Number(rawValue);
        if (Number.isNaN(id)) return;
        const tempFindLogo = optionsLogos.find(logo => logo.id === id) || { id: 0, image: null, name: 'default' };
        dispatch(setLogo(tempFindLogo));
        // Persiste a escolha do usuário
        try {
            localStorage.setItem('selectedLogoId', String(id));
        } catch {}
    }

    const handleSaveContactOptions = (event) => {
        if (t('preview.save-contact') !== event.target.value) {
            let tempSaveContactOption = saveContactOptions.find(option => option.value === event.target.value)
            
            if (tempSaveContactOption.value === "PHONE_NUMBER" && !userRedux.phone) {
                toast.error(t("form.missing-phone-field"))
                dispatch(setSaveContactOptions({ label: null, value: "default" }))

                return
            }

            if (tempSaveContactOption.value === "WHATSAPP" && !userRedux.whatsapp) {
                toast.error(t("form.missing-whatsapp-field"))
                dispatch(setSaveContactOptions({ label: null, value: "default" }))

                return
            }
            
            dispatch(setSaveContactOptions(tempSaveContactOption))
        } else {
            dispatch(setSaveContactOptions(null))
        }
    }

    const handleMutationError = (err) => {
        const graphQLMessage = err?.graphQLErrors?.map((e) => e.message).filter(Boolean).join(' | ')
        const networkMessage = err?.networkError?.result?.errors?.map((e) => e.message).filter(Boolean).join(' | ')
            || err?.networkError?.message
        const detail = graphQLMessage || networkMessage || err?.message
        console.error('[register] Erro ao atualizar usuário', err)
        if (detail) console.error('[register] Detalhe:', detail)
        toast.error(t('form.errorAlert'))
        dispatch(setLoadingForm(false))
    }

    const handleMutationSuccess = () => {
        toast.success(t('form.successAlert'))
        dispatch(setLoadingForm(false))
    }

    async function submitUpdateUser(event) {
        event.preventDefault()
        if (userRedux.loadingForm) return

        try {
            dispatch(setLoadingForm(true))

            let whatsappDigits = (userRedux?.whatsapp || '').replace(/[^0-9]/g, '')
            // Campo já tem prefixo +55 na UI; remove DDI duplicado se veio do banco
            if (whatsappDigits.startsWith('55') && whatsappDigits.length >= 12) {
                whatsappDigits = whatsappDigits.slice(2)
            }

            const saveContactValue = userRedux?.saveContactOption?.value && userRedux.saveContactOption.value !== 'default'
                ? userRedux.saveContactOption.value
                : userInfo.save_contact_with

            let userInfoUpdates = {
                name: userRedux.username || userInfo.name,
                department: userRedux.department || userInfo.department,
                linkedin: userRedux.linkedin ?? null,
                phone: userRedux.phone || null,
                role: userRedux.role || userInfo.role,
                unity: userRedux.unity || userInfo.unity,
                whatsapp: whatsappDigits || null,
            }

            if (saveContactValue && saveContactValue !== 'default') {
                userInfoUpdates.save_contact_with = saveContactValue
            }

            const requiredOk = userInfoUpdates.name
                && userInfoUpdates.department
                && userInfoUpdates.role
                && userInfoUpdates.unity
                && userInfoUpdates.save_contact_with
                && userInfo.email
            if (!requiredOk) {
                dispatch(setLoadingForm(false))
                return toast.error(t('form.unfilledFields'))
            }

            if (image) {
                const responseFile = await minioUploadFile(image, 'user')
                if (!responseFile?.data?.data?.[0]?.key) {
                    dispatch(setLoadingForm(false))
                    console.error('[register] Upload de imagem sem key válida', responseFile)
                    return toast.error(t('form.errorAlert'))
                }
                userInfoUpdates.image = responseFile.data.data[0].key
            }

            if (!userInfo.id) {
                dispatch(setLoadingForm(false))
                return toast.error(t('form.uninformedUserAlert'))
            }

            // email é somente leitura (AD); envia só no insert de idioma EN/ES
            const insertUserInfo = {
                ...userInfoUpdates,
                email: userInfo.email,
                user_id: userInfo.user_id,
                id: userInfo.id,
            }
            if (!userInfo.language) {
                switch (userRedux.typeLanguage) {
                    case "pt":
                        userUpdatePt({
                            variables: {
                                id: userInfo.id,
                                _set: userInfoUpdates
                            }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                        break;
                    case "en":
                        userUpdateEn({
                            variables: {
                                id: userInfo.id,
                                _set: userInfoUpdates
                            }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                        break;
                    case "es":
                        userUpdateEs({
                            variables: {
                                id: userInfo.id,
                                _set: userInfoUpdates
                            }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                        break;
                    default:
                        userUpdatePt({
                            variables: { id: userInfo.id, _set: userInfoUpdates }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                }
            } else {
                switch (userInfo.language) {
                    case "en":
                        insertEn({
                            variables: {
                                object: insertUserInfo
                            }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                        break;
                    case "es":
                        insertEs({
                            variables: {
                                object: insertUserInfo
                            }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                        break;
                    default:
                        insertEn({
                            variables: { object: insertUserInfo }
                        }).then(handleMutationSuccess).catch(handleMutationError)
                }
            }

        } catch (err) {
            console.error('[register] Erro inesperado no submit', err)
            toast.error(t('form.errorAlert'))
            dispatch(setLoadingForm(false))
        }
    }

    useEffect(() => {
        let whatsappValue = userInfo.whatsapp || ''
        const digits = String(whatsappValue).replace(/[^0-9]/g, '')
        if (digits.startsWith('55') && digits.length >= 12) {
            whatsappValue = digits.slice(2)
        } else {
            whatsappValue = digits || whatsappValue
        }

        dispatch(setUsername(userInfo.name))
        dispatch(setUnity(userInfo.unity))
        dispatch(setDepartment(userInfo.department))
        dispatch(setEmail(userInfo.email))
        dispatch(setLinkedin(userInfo.linkedin))
        dispatch(setWhatsapp(whatsappValue))
        dispatch(setPhone(userInfo.phone))
        dispatch(setRole(userInfo.role))
        dispatch(setSaveContactOptions(
            userInfo.save_contact_with
                ? { label: userInfo.save_contact_with, value: userInfo.save_contact_with }
                : { label: null, value: 'default' }
        ))
    // dispatch não incluído para evitar re-render desnecessário
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRedux.typeLanguage, userInfo])

    // Restaura a logo selecionada anteriormente (persistida em localStorage)
    useEffect(() => {
        try {
            const saved = localStorage.getItem('selectedLogoId');
            const id = saved != null ? Number(saved) : 0;
            if (!Number.isNaN(id)) {
                const found = optionsLogos.find(l => l.id === id) || { id: 0, image: null, name: 'default' };
                dispatch(setLogo(found));
            }
        } catch {}
        // executar apenas uma vez no mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <>
            {/* Título removido (vazio) */}
            <Form className="m-0 p-3" onSubmit={submitUpdateUser}>
                <Row className="m-0">
                    <Col md={12}>

                        <label style={{ cursor: 'pointer' }} onChange={handleFile} htmlFor="formId">
                            <Input name="formId" type="file" id="formId" hidden />

                            {userRedux.previewImage ? (
                                <>
                                    <Picture
                                        style={{ borderRadius: "50%", border: '3px solid #19227D' }}
                                        src={userRedux.previewImage}
                                    />
                                    <img
                                        src={edit}
                                        style={{ marginTop: '5em', marginLeft: '-2em' }}
                                        alt=""
                                    />
                                </>
                            ) :
                                <Picture src={picture} />
                            }


                        </label>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="fullName">
                                {t('form.name')}
                            </LabelRegister>
                            <Input
                                defaultValue={userRedux.username || userInfo.name}
                                value={userRedux.username}
                                id="fullName"
                                name="fullName"
                                type="text"
                                required
                                onChange={e => { dispatch(setUsername(e.target.value)) }}
                            />
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="cargo"  className="text-capitalize">
                                {t('form.office')}
                            </LabelRegister>
                            <Input
                                defaultValue={userRedux.role || userInfo.role}
                                value={userRedux.role}
                                id="cargo"
                                name="cargo"
                                type="text"
                                required
                                onChange={e => dispatch(setRole(e.target.value))}
                            />
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="setor" className="text-capitalize">
                                {t('form.department')}
                            </LabelRegister>
                            <Input
                                defaultValue={userRedux.department || userInfo.department}
                                id="setor"
                                name="setor"
                                type="text"
                                required
                                value={userRedux.department}
                                onChange={e => dispatch(setDepartment(e.target.value))}
                            />
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="unidade"  className="text-capitalize">
                                {t('form.unity')}
                            </LabelRegister>
                            <Input
                                defaultValue={userRedux.unity || userInfo.unity}
                                value={userRedux.unity}
                                id="unidade"
                                name="unidade"
                                required
                                type="text"
                                onChange={e => dispatch(setUnity(e.target.value))}
                            />
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="fone"  className="text-capitalize">
                                {t('form.telephone')}
                            </LabelRegister>
                            <Input
                                id="fone"
                                name="fone"
                                type="tel"
                                value={userRedux.phone}
                                defaultValue={userRedux.phone || userInfo.phone}
                                onChange={e => dispatch(setPhone(e.target.value))}
                            />
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="whatsapp" className="text-capitalize">
                                {t('form.whatsapp')}

                                <SlInfo size={20} id="whatsapp-alert" color="info" className="mx-2" />
                                <Tooltip
                                    isOpen={whatsappTooltipOpen}
                                    target="whatsapp-alert"
                                    toggle={toggleWhatsapp}
                                >
                                    {t('form.whatsapp-alert')}
                                </Tooltip>
                            </LabelRegister>
                            <InputGroup>
                                <InputGroupText>
                                    +55
                                </InputGroupText>
                                <Input
                                    id="whatsapp"
                                    name="whatsapp"
                                    type="text"
                                    value={userRedux.whatsapp}
                                    defaultValue={userRedux.whatsapp || userInfo.whatsapp}
                                    onChange={handleWhats}
                                />
                            </InputGroup>
                        </FormArea>
                    </Col>
                    <Col md={6}>
                        <FormArea>
                            <LabelRegister for="email"  className="text-capitalize">
                                {t('form.email')}
                            </LabelRegister>
                            <InputGroup>
                                <InputGroupText
                                    id="duvidas"
                                >
                                    <SlInfo size={20} color="info" />
                                </InputGroupText>
                                <Input
                                    defaultValue={userRedux.email || userInfo.email}
                                    onChange={e => dispatch(setEmail(e.target.value))}
                                    id="email"
                                    name="email"
                                    disabled
                                    type="email"
                                />
                                <Tooltip
                                    isOpen={tooltipOpen}
                                    target="duvidas"
                                    toggle={toggle}
                                >
                                    {t('form.alert')}
                                </Tooltip>
                            </InputGroup>
                        </FormArea>
                    </Col>
                   
                    {userRedux.tab === '2' && (
                        <Col md={6}>
                            <FormArea>
                                <LabelRegister for="logos"  className="text-capitalize">
                                    {t('form.logos')}
                                </LabelRegister>
                                <Input
                                    id="logo"
                                    name="logos"
                                    type="select"
                                    value={userRedux.logo?.id ?? 0}
                                    onChange={handleSelectLogo}
                                >
                                    {optionsLogos.map(logos => (
                                        <option key={logos.id} value={logos.id}>
                                            {logos.name === 'default' ? t('preview.logo') : logos.name}
                                        </option>
                                    ))}
                                </Input>
                            </FormArea>
                        </Col>
                    )}

                    {userRedux.tab === '1' && (
                        <Col md={6}>
                            <FormArea>
                                <LabelRegister for="save-contact-options"  className="text-capitalize">
                                    {t('form.save-contact-options')}

                                    <SlInfo size={20} id="save-contact-alert" color="info" className="mx-2" />
                                    <Tooltip
                                        isOpen={saveContactTooltipOpen}
                                        target="save-contact-alert"
                                        toggle={toggleSaveContact}
                                    >
                                        {t('form.save-contact-alert')}
                                    </Tooltip>
                                </LabelRegister>
                                <Input
                                    id="save-contact-options"
                                    name="save-contact-options"
                                    type="select"
                                    onChange={handleSaveContactOptions}
                                    value={userRedux.saveContactOption?.value}
                                >
                                    {saveContactOptions.map(option => {
                                        return (
                                            <option value={option.value}>
                                                {option.value === "default" ? t('preview.save-contact') : option.label}
                                                {/* {option.name == 'default' ? t('preview.logo') : option.name} */}
                                            </option>
                                        )
                                    })}
                                </Input>
                            </FormArea>
                        </Col>
                    )}

                </Row>
                <Row className="p-4 mt-5 justify-content-end text-capitalize">
                    <ButtonPrimary
                        type="submit"
                        disabled={userRedux.loadingForm}
                        style={{ width: "120px" }}>

                        {userRedux.loadingForm ? <div className="d-flex justify-content-center"> <LoadinSpinner color='white' /> </div> : t('form.button')}
                    </ButtonPrimary>

                </Row>

            </Form>
        </>
    )
}

export default Register